import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { AdCampaignVisualTypeEnum } from 'src/Redux/ad-campaignApi'

import { AddVisualModalControls } from '../AdsVisualModal/AddVisualModalControls'
import { AdsPlacementsModalControls } from '../AdsPlacementsModal/AdsPlacementsModalControls'

import { AddTargetLocationsControls } from './AddTartgetLocationsControls'

const Container = styled.div`
  display: flex;
  padding: 24px;
  margin-bottom: 70px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

export interface AdsAdSettingsProps {
  visualType?: AdCampaignVisualTypeEnum | null
  countries?: Array<string>
}

export const AdsAdSettings: FC<AdsAdSettingsProps> = ({
  visualType,
  countries,
}) => (
  <Container>
    <Title>Set ad settings</Title>
    <AddTargetLocationsControls countries={countries} />
    <AddVisualModalControls visualType={visualType} />
    <AdsPlacementsModalControls />
  </Container>
)
